import React, { useEffect, useMemo, useRef } from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./UnreachableError.scss";
import { LinkMail } from '@randajan/jet-react/dom/link';
import { createPulse } from '@randajan/pulse';
import { localeBeam } from '../../../../assets/beams/localeBeam';
import { _defaultSay } from '../../../../../arc/locale/consts';


export const UnreachableError = (props)=>{
    const {} = props;

    const ref = useRef();

    const pulse = useMemo(_=>createPulse({
        align:false,
        autoStart:true,
        runOnStart:true,
        noMeta:true,
        interval:15000,
        onPulse:_=>localeBeam.reset()
    }), []);

    useEffect(_=>{
        const int = setInterval(_=>{
            const el = ref.current;
            if (!el) { return; }
            el.innerText = _defaultSay.duration(pulse.countdown+1000);
        }, 50);
        return _=>{
            pulse.stop();
            clearInterval(int);
        }
    }, [pulse]);
    
    return (
        <Block className="UnreachableError" caption="This is certainly not normal">
            <div className="flex message">
                <span>Please try again later or</span>
                <span>reach us via email</span>
                <LinkMail>blimp@blimp.wtf</LinkMail>
            </div>
            <div className="flex countdown">
                We will try again in
                <span ref={ref}/>
            </div>
        </Block>
    )
}

